import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation
} from '@angular/core';
import * as moment from 'moment';
import { OrderDetails } from '../../../models/orders/details';
import { ClientModel } from '../../../../shared/models/client.model';

@Component({
    selector: 'account-orders-details-actions',
    templateUrl: './account.orders.details.actions.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountOrdersDetailsActionsComponent {
    public loading = false;

    @Input('client') client: ClientModel;
    @Input('order') order: OrderDetails;
    @Output('updated') updated: EventEmitter<any> = new EventEmitter();

    /**
     * Check if schedule is already passed to allow update.
     **/
    public isPastSchedule() {
        const scheduleDate$ = moment(this.order.schedule.date);
        const now = moment();
        return scheduleDate$.diff(now, 'days') < 0;
    }
    /**
     * Emit updated event output.
     **/
    public emitUpdated() {
        this.updated.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/account/orders/details/actions/account.orders.details.actions.component.ts